import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { ValidationService } from 'src/app/validation.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-payment-voucher-create',
  templateUrl: './payment-voucher-create.component.html',
  styleUrls: ['./payment-voucher-create.component.scss']
})
export class PaymentVoucherCreateComponent implements OnInit {

  @ViewChild('fileUploader', {static: true}) fileUploader: ElementRef;

  showLoader = false;

  dates:any = {
    creationDate:Date,
    paymentDate:Date
  }

  createData: any = {
    bank_details: {
      name: '',
      acc_no: '',
      fsc: '',
      doc_no: '',
    }
  };

  types = [
    {
      value: 'BANK',
      name: 'Bank'
    },
    {
      value: 'CASH',
      name: 'Cash'
    }
  ];
  
  paymentVoucherFormData: any = new FormData();

  constructor(private dialog: MatDialogRef<PaymentVoucherCreateComponent>, private validationService: ValidationService,
              private snackbar: SnackbarService, private translation: TranslateService, private http: HttpService,
              private valid: ValidationService,) { }

  ngOnInit() {
  }

  createPaymentVoucher() {

    if (this.validate()) {
      this.showLoader = true;

      this.http.post('v2/payment_voucher', this.createData).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data.statusCode == 200) {
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.PAYMENT_VOUCHER.SUCCESS.VOUCHER_CREATED'), '');
            this.closeModal(data);
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 401) {
            this.valid.logout();
          }
        }
      );
    }

  }

  validate() {
    let valid = true;
    if (!this.validationService.isEmpty(this.createData.payment_date) && !this.validationService.isEmpty(this.createData.created_date) && !this.validationService.isEmpty(this.createData.payee) && !this.validationService.isEmpty(this.createData.debit)
      && !this.validationService.isEmpty(this.createData.credit) && !this.validationService.isEmpty(this.createData.type) && !this.validationService.isEmpty(this.createData.narration) && !this.validationService.isEmpty(this.createData.amount)) {
        if (this.createData.type == 'BANK') {
          if (this.validationService.isEmpty(this.createData.bank_details.name)) {
            valid = false;
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.PAYMENT_VOUCHER.VALIDATION.NAME_OF_BANK'), '', 'err');
            return valid;
          } else if (this.validationService.isEmpty(this.createData.bank_details.acc_no)) {
            valid = false;
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.PAYMENT_VOUCHER.VALIDATION.ACCOUNT_NO'), '', 'err');
            return valid;
          } else if (this.validationService.isEmpty(this.createData.bank_details.fsc)) {
            valid = false;
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.PAYMENT_VOUCHER.VALIDATION.IFSC'), '', 'err');
            return valid;
          } else if (this.validationService.isEmpty(this.createData.bank_details.doc_no)) {
            valid = false;
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.PAYMENT_VOUCHER.VALIDATION.CHEQUE_NO'), '', 'err');
            return valid;
          } else {
            return valid;
          }
        } else {
          delete this.createData.bank_details;
          return valid;
        }
    } else {
      valid = false;
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.PAYMENT_VOUCHER.VALIDATION.FILL_ALL'), '', 'err');
      return valid;
    }
  }

  selectType(type) {
    this.createData.type = type.value;
  }

  setDateOfPayment(value) {
    const t1 = DateTime.fromJSDate(value.paymentDate).toFormat('dd/MM/yyyy 00:00:00');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy 00:00:00'); // get the epoch time
    this.createData.payment_date = epoch.ts;
  }

  setCreationDate(value) {
    const t1 = DateTime.fromJSDate(value.creationDate).toFormat('dd/MM/yyyy 00:00:00');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy 00:00:00'); // get the epoch time
    this.createData.created_date = epoch.ts;
  }

  closeModal(data: any = '') {
    this.dialog.close(data);
  }

  fileChanged(event: any) {
    if (event.target.files.length) {
      const ins = event.target.files.length;
      for (let x = 0; x < ins; x++) {
        this.paymentVoucherFormData.append('docs', event.target.files[x]);
      }
    } else {
      this.paymentVoucherFormData.delete('docs');
    }
  }

}
